import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaginatorIntlService extends MatPaginatorIntl {
  itemsPerPageLabel = 'Items per page';
  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';
  lastPageLabel = 'Last page';
  firstPageLabel = 'First page';

  constructor(protected translateService: TranslateService) {
    super();
    this.translateService.onLangChange.subscribe(() => {
      this.translateLabels();
    });
    this.translateLabels();
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const of = this.translateService.instant('PAGINATOR.OF');
    if (length === 0 || pageSize === 0) {
      return '0 ' + of + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
  };

  translateLabels = (): void => {
    this.itemsPerPageLabel = this.translateService.instant('PAGINATOR.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translateService.instant('PAGINATOR.NEXT_PAGE');
    this.previousPageLabel = this.translateService.instant('PAGINATOR.PREVIOUS_PAGE');
    this.lastPageLabel = this.translateService.instant('PAGINATOR.LAST_PAGE');
    this.firstPageLabel = this.translateService.instant('PAGINATOR.FIRST_PAGE');
  };
}
